/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { DirectoryHorizontalNav } from './ui/index.tsx';

const LazyDirectoryNav = lazyForPaint<typeof DirectoryHorizontalNav>(
	() =>
		import(/* webpackChunkName: "async-kb-nav" */ './ui/index.tsx').then(
			({ DirectoryHorizontalNav }) => DirectoryHorizontalNav,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncDirectoryNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-jsm-directory-nav" fallback={null}>
		<LazyDirectoryNav />
	</Placeholder>
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { DirHeaderActionsContainer } from './ui/dir-header-actions-container';
